import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.min.css"; // Ensure modal CSS is loaded

const tabListContent = [
  {
    porftoliItems: [
      {
        img: "/img/portfolio/1.jpg",
        title: "Štěpán Juránek",
        meta: "Místostarosta Židenic",
        portfolioLink: "https://www.instagram.com/",
        videoId: "DIfxwE3h5Xg", // YouTube Video ID for candidate
      },
      {
        img: "/img/portfolio/2.jpg",
        title: "Lucie Grůzová",
        meta: "Místostarostka Židenic",
        portfolioLink:
          "https://dribbble.com/shots/16545341-Imroz-Vue-JS-Creative-Agency-Portfolio-Template",
        videoId: "6_mhj4Kyp14",
      },
      {
        img: "/img/portfolio/14.jpg",
        title: "Jiří Pavlík",
        meta: "Manažer",
        portfolioLink:
          "https://dribbble.com/shots/16529407-Deski-Saas-Software-React-Template",
        videoId: "PTKAhZiBmqE",
      },
      {
        img: "/img/portfolio/22.jpg",
        title: "Viktor Šulc",
        meta: "starosta Orla, podnikatel",
        portfolioLink:
          "https://dribbble.com/shots/16529282-Shane-Personal-Portfolio-React-Template",
        videoId: "kqG62EObsPY",
      },
    ],
  },
  {
    porftoliItems: [
      {
        img: "/img/portfolio/22.jpg",
        title: "Shane Design",
        meta: "Design",
        portfolioLink:
          "https://dribbble.com/shots/16529282-Shane-Personal-Portfolio-React-Template",
        videoId: "6u5xDf8GNrc",
      },
    ],
  },
  {
    porftoliItems: [
      {
        img: "/img/portfolio/1.jpg",
        title: "My Story",
        meta: "Design",
        portfolioLink: "https://www.instagram.com/",
        videoId: "6u5xDf8GNrc",
      },
      {
        img: "/img/portfolio/2.jpg",
        title: "Design Trend",
        meta: "Branding",
        portfolioLink:
          "https://dribbble.com/shots/16545341-Imroz-Vue-JS-Creative-Agency-Portfolio-Template",
        videoId: "6u5xDf8GNrc",
      },
    ],
  },
  {
    porftoliItems: [
      {
        img: "/img/portfolio/15.jpg",
        title: "Soft Cream",
        meta: "Photography",
        portfolioLink:
          "https://dribbble.com/shots/16529407-Deski-Saas-Software-React-Template",
        videoId: "6u5xDf8GNrc",
      },
    ],
  },
];

const Portfolio = () => {
  const [isOpen, setOpen] = useState(false);
  const [currentVideoId, setCurrentVideoId] = useState("");

  const handleOpenVideo = (videoId) => {
    setCurrentVideoId(videoId);
    setOpen(true);
  };

  return (
    <div className="shane_tm_section" id="portfolio">
      <div className="shane_tm_portfolio">
        <div className="container">
          <div className="positon-relative">
            <div className="shane_tm_title">
              <div className="title_flex">
                <div className="left">
                  <h3>Naši kandidáti</h3>
                </div>
              </div>
            </div>

            {/* YouTube Modal Component */}
            <ModalVideo
              channel="youtube"
              autoplay
              isOpen={isOpen}
              videoId={currentVideoId}
              onClose={() => setOpen(false)}
            />

            <div className="portfolio_filter">
              <Tabs>
                <div className="portfolio_list has-effect">
                  {tabListContent.map((tabContent, i) => (
                    <TabPanel key={i}>
                      <ul className="gallery_zoom">
                        {tabContent.porftoliItems.map((val, idx) => (
                          <li
                            key={idx}
                            data-aos="fade-right"
                            data-aos-duration="1200"
                            data-aos-delay={val.delayAnimation}
                          >
                            <div className="inner">
                              {/* Video Card Container */}
                              <div
                                className="entry shane_tm_portfolio_animation_wrap video_card_wrapper"
                                onClick={() => handleOpenVideo(val.videoId)}
                              >
                                <img
                                  src={val.img}
                                  alt={val.title}
                                  role="button"
                                />
                                {/* Play Button Overlay */}
                                <div className="play_btn_overlay">
                                  <span className="rounded"></span>
                                </div>
                              </div>

                              {/* Info section below card */}
                              <div className="mobile_title">
                                <h3>
                                  <a
                                    href={val.portfolioLink}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                  >
                                    {val.title}
                                  </a>
                                </h3>
                                <span>{val.meta}</span>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </TabPanel>
                  ))}
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;